import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-percentage-column-molecule',
  templateUrl: './percentage-column-molecule.component.html',
  styleUrls: ['./percentage-column-molecule.component.scss']
})
export class PercentageColumnMoleculeComponent {
  @Input() data: any;
  @Input() header: any;
}
